// extracted by mini-css-extract-plugin
export var growableInput = "_97-0";
export var tagContainer = "_97-2";
export var textInput = "_97-1";